export default "__VITE_ASSET__DDLG$pVF__"